import { Capacitor } from "@capacitor/core";
import { NoopLeaderboardClient, type LeaderboardClient } from "@yjsgames/leaderboard";
import type { GpgsPort } from "@yjsgames/gpgs-ports";
import { GpgsLeaderboardClient } from "./GpgsLeaderboardClient.js";
import { GameCenterLeaderboardClient } from "./GameCenterLeaderboardClient.js";

/**
 * 플랫폼별 LeaderboardClient 결정(DIP 분기 팩토리).
 *  - Android: GPGS(GpgsLeaderboardClient, 기존 GpgsPort 재사용)
 *  - iOS: Game Center(GameCenterLeaderboardClient, GameKit)
 *  - 웹/그 외: Noop(제출 무동작)
 *
 * iOS는 `ios/` 네이티브 프로젝트 + GameCenterPlugin.swift 배치 후 동작(그 전엔 native 부재로 graceful no-op).
 *
 * @param gpgsPort GPGS 포트 getter — Android 경로에서 점수 제출에 재사용.
 */
export function createLeaderboardClient(gpgsPort: () => GpgsPort): LeaderboardClient {
  if (!Capacitor.isNativePlatform()) return new NoopLeaderboardClient();
  const platform = Capacitor.getPlatform();
  if (platform === "android") return new GpgsLeaderboardClient(gpgsPort);
  if (platform === "ios") return new GameCenterLeaderboardClient();
  return new NoopLeaderboardClient();
}
